export default __webpack_public_path__ + "static/feature-img-7a39b5fbeb84413a653a3c8786c81784.jpg";